export const RELATIONSHIPS = [
  { id: "customer", label: "Current customer", short: "Customer", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  { id: "wishlist", label: "Wishlist / target", short: "Wishlist", cls: "bg-ism-teal/10 text-ism-teal border-ism-teal/30" },
];

export const DEFAULT_OPTIONS = [
  { id: "auto", label: "Let the AI decide", hint: "Infers from words like 'client', 'signed', 'target'" },
  { id: "customer", label: "All current customers" },
  { id: "wishlist", label: "All wishlist targets" },
];

export const relationshipCls = (rel) => (RELATIONSHIPS.find((r) => r.id === rel) || RELATIONSHIPS[1]).cls;
export const relationshipLabel = (rel) => (RELATIONSHIPS.find((r) => r.id === rel) || RELATIONSHIPS[1]).short;

export const ACCEPT = ".csv,.xlsx,.xls,.txt,.md,.pdf,.docx,.png,.jpg,.jpeg,.webp";

export const summarize = (items) => ({
  total: items.length,
  accounts: items.filter((i) => i.kind === "account").length,
  contacts: items.filter((i) => i.kind === "contact").length,
  customer: items.filter((i) => i.relationship === "customer").length,
  wishlist: items.filter((i) => i.relationship === "wishlist").length,
  existing: items.filter((i) => i.existingAccountId).length,
});

export const mergeItems = (current, incoming) => {
  const key = (i) => `${i.kind}|${(i.website || i.companyName || "").toLowerCase()}|${(i.contactEmail || i.contactName || "").toLowerCase()}`;
  const seen = new Set(current.map(key));
  return [...current, ...incoming.filter((i) => !seen.has(key(i)))];
};

export const websiteItem = (name) => ({
  id: `web-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`, kind: "account", companyName: name, website: "", industry: "",
  contactName: "", contactTitle: "", contactEmail: "", notes: "Named on your website", relationship: "customer", confidence: "medium", source: "website",
});
